import { ToggleButton } from '@duke-hq/ui/components/ToggleButton/ToggleButton';
import { useNavButton } from '@duke-hq/ui/components/MainSidebar/useNavButton';
import { NavButton } from '@duke-hq/ui/components/MainSidebar/NavButton';
import { useIsWiderThan940px } from '@duke-hq/ui/components/hooks/useIsWiderThan940px';
import { useSubSidebar } from '@duke-hq/ui/components/SubSidebar/useSubSidebar';
import { useAuthAdmin } from './AuthProviderAdmin';
import { trpcAdmin } from '@duke-hq/app-admin-web/lib/trpcAdmin';
import { useAdminNavItems } from './adminNavItems';

export function SidebarDrawerAdmin() {
  const { expanded, toggleExpanded } = useNavButton();
  const [isLargerThan940] = useIsWiderThan940px();

  return (
    <ToggleButton
      isOpen={expanded}
      onClick={toggleExpanded}
      aria-label="Open menu"
      display={{ base: 'inline-flex' }}
      hidden={!isLargerThan940}
    />
  );
}

export function SideBarNavButtons() {
  const session = useAuthAdmin();
  const [isLargerThan940] = useIsWiderThan940px();
  const { expanded } = useNavButton();
  const { closeSubSidebar, openSubSidebar } = useSubSidebar();
  const { data } = trpcAdmin.notifications.unreadTicketCount.useQuery();
  const unreadCount = data?.unreadCount ?? 0;
  const menuItems = useAdminNavItems();

  if (!session?.user) {
    return null;
  }

  return (
    <>
      {menuItems.map((item) => (
        <NavButton
          key={item.label}
          label={item.label}
          icon={item.icon}
          link={item.link}
          badge={item.link === '/support' && unreadCount > 0 ? unreadCount : undefined}
          iconStyles={{}}
          onClick={item.hasSubSidebar ? openSubSidebar : closeSubSidebar}
          expanded={isLargerThan940 ? expanded : false}
        />
      ))}
    </>
  );
}
